import React from 'react'

import { Navigate } from 'react-router-dom'
import { UserAuth } from '../context/AuthContext'
import { Variables } from '../context/VariableContext'

const ProtectedRoute = ({ children }) => {
    const { user } = UserAuth()
    const { openLogin, setOpenLogin } = Variables();

    if (!user) {
        setOpenLogin(true)
        return <Navigate to='/fr' />
    }
    return children

}

export default ProtectedRoute